import { useQuery } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'
import { type Quote } from '../prospects/types'

export function useGetQuotes ({
  prospectId,
  pagination,
}: {
  prospectId: string;
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
}) {
  return useQuery<PaginatedResponse<Quote>, GrapeAPIErrorType>({
    queryKey: [
      'quoting',
      'prospects',
      prospectId,
      'quotes',
      'pagination',
      pagination,
    ],
    queryFn: async () => {
      const queryParams: Record<string, any> = {
        'page[number]': pagination.pageIndex.toString(),
        'page[size]': pagination.pageSize.toString(),
      }
      const queryString = new URLSearchParams(queryParams).toString()
      const response = await fetch(
        `/api/web/quoting/prospects/${prospectId}/quotes?${queryString}`, // eslint-disable-line thatch/no-bare-fetch
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
  })
}
